import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { fecthIdDrinkRandom } from '../services/fetchRandomIdRecipe';
import './css/Explore.css';

function ExploreDrinks() {
  const [idRecipe, setIdRecipe] = useState('');

  useEffect(() => {
    const getId = async () => {
      const data = await fecthIdDrinkRandom();
      setIdRecipe(data);
    };
    getId();
  }, []);

  const history = useHistory();
  return (
    <div className="e-d-page">
      <Header Title="Explore Drinks" />
      <div className="e-buttons">
        <button
          type="button"
          data-testid="explore-by-ingredient"
          className="e-btn"
          onClick={ () => history.push('/explore/drinks/ingredients') }
        >
          By Ingredient
        </button>
        <button
          type="button"
          disabled="true"
          className="e-nat-btn"
        >
          By Nationality
        </button>
        <button
          type="button"
          data-testid="explore-surprise"
          className="e-btn"
          onClick={ () => history.push(`/drinks/${idRecipe}`) }
        >
          Surprise me!
        </button>
      </div>
      <Footer />
    </div>
  );
}

export default ExploreDrinks;
